// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import moment from 'vue-moment'
import permission from './modules/permission'
import item from './modules/item'
import { extend, localize } from 'vee-validate'
import { required, numeric, alpha_num as alphaNum, digits, min, max, regex, oneOf, max_value as maxValue, min_value as minValue } from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'

// Bootstrap.css
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VueSession)
Vue.use(moment)

Vue.mixin(permission)
Vue.mixin(item)

Vue.config.productionTip = false
axios.defaults.withCredentials = true
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.get['Pragma'] = 'no-cache'

extend('required', required)
extend('numeric', numeric)
extend('digits', digits)
extend('min', min)
extend('max', max)
extend('alpha_num', alphaNum)
extend('oneOf', oneOf)
extend('max_value', maxValue)
extend('min_value', minValue)
localize('ja', ja)
extend('regex', {
  ...regex,
  message: '{_field_}は「yyyy-mm-dd」形式で入力してください。'}
)

const docomoNumDigits = {
  params: ['size'],
  message: '{_field_}は{size}文字の英数字でなければなりません。',
  validate (value, {size}) {
    if (String(value).length === Number(size)) {
      if (String(value).match(/^[a-zA-Z0-9]+$/)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
}
extend('docomo_num_digits', docomoNumDigits)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js